import React from 'react'

import AImg from '../../../external/components/media/img/AImg'

export const AA_ICON_URL = '/images/aamLegend.png'

const AAIcon = () => (
  <AImg
    imageURL={'/images/aamLegend.png'}
    responsive={false}
    alt={'ACTIVE Advantage discount'}
    title={'ACTIVE Advantage discount'}
  />
)

export default AAIcon
